import {eTipoPermissao} from "@/enums/ePermissoes";

export default [
 {
  description: "Repasses do Projeto",
  path: "/prestacaocontas/pcoprojeto/:pcoProjetoId/repasses",
  parent: "pcoprojeto",
  name: "pcoprojeto_repasses",
  component: () => import("@/views/prestacaocontas/pcoprojetorepasse/CadastroComGrid.vue"),
  meta: {
   permissions: [eTipoPermissao.CONVENIOPROJETOSNOVO_MENU_1500100199],
  },
  goesToMenu: false,
 },
]
